const BRC_GENERATION = 2;
const RB_GENERATION = 4;

function throwUnknownRunbookTypeError(runbookGeneration) {
  throw new Error("Not implemented logic for unknown runbook generation: " + runbookGeneration);
}

function isHotsiteRunbookGeneration(runbookGeneration) {
	return [BRC_GENERATION, RB_GENERATION].indexOf(runbookGeneration) !== -1
}

function getSafeBootValue(values, isEnabled) {
  if (!isEnabled) {
    return null;
  } else {
    for (let value of values) {
      if (value !== undefined) {
        return value;
      }
    }
    return 0;
  }
}

function clearErrors(block) {
  block.find('i.fa.error').remove();
  block.find(':input.field-error').removeClass('field-error');
  block.find('.error-message').hide();
}

function showErrors(block, errors) {
  const validationErrors = $.extend({}, errors || {});
  const details = validationErrors.details;
  const title = validationErrors.title;
  delete validationErrors.details;
  delete validationErrors.title;

  if (details !== undefined) {
    $.each(details, function (key, message) {
      block.find('.error-detail.' + key).html(message).parents('.error-message').fadeIn();
    });
  }
  if (title !== undefined) {
    block.find('.error-main').html(title).parents('.error-message').fadeIn();
  }

  $.each(validationErrors, function (key, message) {
    const exclamation = $('<i class="fa fa-exclamation-circle error"></i>').attr('data-axtooltip-class', 'error')
            .attr('data-axtooltip', message);
    const input = block.find(':input[name="' + key + '"], \
                            :input[data-name="' + key + '"], \
                            .input-group[data-name="' + key + '"] input[type="text"]');

    if (input.length > 0) {
      input.addClass('field-error');
      const group = input.parents('.input-group[data-name="' + key + '"]');
      if (group.length > 0) {
        group.after(exclamation);
      } else {
        input.after(exclamation);
      }
    }
  });
}

function handleRunbookPasswordError(validationErrors, postErrorActions) {
  showErrors($('#runbook_summary_section'), validationErrors);
  $.each(validationErrors, function (key, message) {
    const exclamation = $('<i class="fa fa-exclamation-circle error"></i>').attr('data-axtooltip-class', 'error').attr('data-axtooltip', message);
    $('#runbook_list .trow[data-id=' + key + '] input[name=password]').addClass('field-error').after(exclamation);
  });
  postErrorActions();
}

/**
 * RunbookFlow steps
 */
function RunbookFlow(runbookManager) {
  var runbookFlow = this;

  this.baseUrl = '/runbook/';
  this.wizardUrl = this.baseUrl + 'wizard/';

  var btnsSelector = '.js-runbook-button',
      nextBtn = '.js-runbook-next',
      backBtn = '.js-runbook-back',
      finishBtn = '.js-runbook-finish',
      notDisabled = ':not(.disabled)';

  /**
   * Shows validation errors on the wizard's pane.
   * @private
   */
  this.showErrors = function(pane, errors) {
    showErrors(pane, errors);
  };

  /**
   * Clears validation errors on the wizard's pane.
   * @private
   */
  this.clearErrors = function(pane) {
    clearErrors(pane);
  };

  this.saveRunbook = function(data, afterSaveSuccess, onSavingFailed) {
    var saveStep = function(stepIndex) {
          if (stepIndex > (runbookFlow.steps.length - 1)) {
            afterSaveSuccess();
            this.runbookManager.flowFinished(data.id);
            return;
          }

          var step = runbookFlow.steps[stepIndex] || {},
              onSaveSuccess = function() {
                saveStep(stepIndex + 1);
              };

          if (typeof step.save === 'function') {
            step.save(data, onSaveSuccess, onSavingFailed);
          } else {
            onSaveSuccess();
          }
        };

    saveStep(0);
  };

  this.steps = [
    // step1
    {
      id: 'step1',
      view: 'summary',
      save: function(data, saveSuccess, saveFailed) {
        var runbookSummary = data.steps[this.id] || {},
            params = {
              'client_id': data.client_id,
              'runbook_id': data.id || 0,
              'runbook_name': runbookSummary.runbook_name || 'Runbook',
              'runbook_description': runbookSummary.runbook_description || ''
            };
        const itemsData = data.steps['step2'] || {};
        if (data.id) {
          params.currentPassword = data.password;
        }
        if (itemsData.password) {
          params.password = itemsData.password;
        }

        RUNBOOK_ACTIONS_MANAGER.summary().save(params, function(response) {
          var runbookId = ((response || {}).data || {}).runbook_id;
          if (!!runbookId) {
            data.id = runbookId;
            saveSuccess();
          } else {
            saveFailed();
          }
        }, saveFailed);
      },
      collect: function(pane) {
        return {
          'runbook_name': pane.find('[name=runbook_name]').val(),
          'runbook_description': pane.find('[name=runbook_desc]').val()
        };
      },
      validateNext: function(pane, data, validationSuccess, validationError) {
        var params = {
          'client_id': data.client_id,
          'runbook_id': data.id || 0
        };
        $.extend(params, data.steps[this.id]);

        var success = function() {
              validationSuccess();
            },
            error = function(validationErrors) {
              validationError();
              runbookFlow.showErrors(pane, validationErrors);
            };

        RUNBOOK_ACTIONS_MANAGER.summary().validate(params, success, error);
      },
      afterPaneLoad: function(pane, data) {
        var name = (data.steps[this.id] || {}).runbook_name || '',
            desc = (data.steps[this.id] || {}).runbook_description || '';

        if (name) {
          pane.find('input[name=runbook_name]').val(name);
        }
        if (desc) {
          pane.find('textarea[name=runbook_desc]').val(desc);
        }
      }
    },
    // step2
    {
      id: 'step2',
      view: 'devices',
      /**
       * Deletes deselected runbook items
       * @private
       */
      delete: function(data, deleteSuccess, deleteFailed) {
        var itemsToDelete = (data.steps[this.id] || {}).delete || {};

        if ($.isEmptyObject(itemsToDelete)) {
          deleteSuccess();
          return;
        }

        var params = {
          'client_id': data.client_id,
          'runbook_id': data.id || 0,
          'delete_items': itemsToDelete
        };
        RUNBOOK_ACTIONS_MANAGER.items().delete(params, deleteSuccess, deleteFailed);
      },
      /**
       * Adds selected devices
       * @private
       */
      add: function(data, addSuccess, addFailed) {
        var itemsValuesDataKey = 'step3',
            itemsValues = data.steps[itemsValuesDataKey] || {},
            itemsList = (data.steps[this.id] || {}).list || {},
            newItems = {};

        $.each(itemsList, function(deviceId, item) {
          if (item.runbook_item_id) { return true; }

          var itemToAdd = {},
              deviceValues = itemsValues[deviceId] || {};

          itemToAdd.cores = deviceValues.cores || item.cores || 2;
          itemToAdd.ram = deviceValues.ram || item.ram || 4;
          itemToAdd.priority = deviceValues.priority || item.priority || 'MEDIUM';
          itemToAdd.wait_time = deviceValues.wait_time || item.wait_time || 0;
          itemToAdd.safe_boot = getSafeBootValue([deviceValues.safe_boot, item.safe_boot], deviceValues.safe_boot_enabled || item.safe_boot_enabled);
          itemToAdd.ip_address = deviceValues.ip_address || item.ip_address || item.device_ip_address;
          if (item.has_password) {
            itemToAdd.password = item.password;
          }

          newItems[deviceId] = itemToAdd;
        });

        if ($.isEmptyObject(newItems)) {
          addSuccess();
          return;
        }

        var params = {
              'client_id': data.client_id,
              'runbook_id': data.id || 0,
              'add_items': newItems
            };
        RUNBOOK_ACTIONS_MANAGER.items().add(params, addSuccess, addFailed);
      },
      save: function(data, saveSuccess, saveFailed) {
        var self = this;
        this.delete(data, function() { self.add(data, saveSuccess, saveFailed); }, saveFailed);
      },
      collect: function(pane) {
        const passwordBlock = pane.find('.runbook-password-block:not(.invisible)');
        var rowToItemData = function(i, elem) {
              var itemDataAttrs = $(elem).data(),
                  isSelected = $(elem).has('.selectcell input:checked').length > 0,
                  name = $(elem).find('.runbook-devices').html(),
                  serviceName = $(elem).parents('.axtable').find('[data-app_id='+$(elem).data('rel_app')+'] .runbook-devices .device-name').text();
              let data = {
                'id': itemDataAttrs.id,
                'selected': isSelected,
                'display_name': name,
                'service_name': serviceName,
                'app_generation': itemDataAttrs.app_generation,
                'cores': itemDataAttrs.cores || 2,
                'ram': itemDataAttrs.ram || 4,
                'priority': itemDataAttrs.priority || 'MEDIUM',
                'wait_time': itemDataAttrs.wait_time || 0,
                'os_bits': itemDataAttrs.os_bits || 0,
                'max_cores': itemDataAttrs.max_cores || 16,
                'max_ram': itemDataAttrs.max_ram || 32,
                'runbook_item_id': itemDataAttrs.runbook_item_id,
                'ip_address': itemDataAttrs.ip_address,
                'device_ip_address': itemDataAttrs.device_ip_address,
                'safe_boot': getSafeBootValue([itemDataAttrs.safe_boot], itemDataAttrs.safe_boot_enabled),
                'safe_boot_enabled': itemDataAttrs.safe_boot_enabled,
                'has_password': itemDataAttrs.has_password
              };
              if (data.has_password) {
                data.password = $(elem).find('[name="password"]').val();
              }
              return data;
            };

        var result = {
              list: {},
              delete: {}
            },
            items = pane.find('.axtable.available-devices .trow[data-id]')
                        .map(rowToItemData).toArray();

        if (passwordBlock.length > 0) {
          const password = passwordBlock.find('[name="runbook_password"]').val();
          const confirmPassword = passwordBlock.find('[name="runbook_password_confirm"]').val();
          result.password = password;
          result.confirmPassword = confirmPassword;
        }

        $.each(items, function(i, item) {
          var deviceId = item.id,
              runbookItemId = item.runbook_item_id,
              isSelected = item.selected;

          if (isSelected) {
            result.list[deviceId] = item;
          } else if (runbookItemId) {
            result.delete[deviceId] = {runbook_item_id: runbookItemId};
          }
        });

        return result;
      },
      /**
       * @private
       */
      storeInitialSelection: function(pane) {
        pane.data('selection', this.getCurrentSelection(pane));
      },
      /**
       * @private
       */
      getInitialSelection: function(pane) {
        return pane.data('selection') || [];
      },
      /**
       * @private
       */
      getCurrentSelection: function(pane) {
        return pane.find('.trow[data-id]')
                   .has('.selectcell input:checked')
                   .map(function(i, el) { return $(el).data('id'); })
                   .toArray();
      },
      verifyProtectedSystems: function (pane, params, runbookGeneration, validationSuccess, validationError) {
        const runbookPasswordBlock = pane.find('.runbook-password-block');
        const validationParams = {
          devices_passwords: this.getDevicesPasswords(pane),
          runbook_password: runbookPasswordBlock.find('input[name="runbook_password"]').val(),
          runbook_password_confirm: runbookPasswordBlock.find('input[name="runbook_password_confirm"]').val(),
          runbook_id: params.runbook_id,
          client_id: params.client_id
        };
        const successFunction = function () {
          runbookFlow.clearErrors(pane);
          var success = function () {
            validationSuccess();
          },
          fail = function (runbookWarnings) {
            if (!$.isEmptyObject(runbookWarnings)) {
              var skipFunction = validationSuccess,
                  addDevicesFunction = validationError;
              RUNBOOK_DIALOGS.showRunbookDeviceWarningsDialog(runbookWarnings, skipFunction, addDevicesFunction, runbookGeneration);
            } else {
              validationError();
            }
          };
          RUNBOOK_ACTIONS_MANAGER.items().check(params, success, fail);
        };
        const failFunction = function (validationErrors) {
          if (Object.keys(validationErrors.items).length > 0) {
            $.each(validationErrors.items, function (key, message) {
              const passwordBlock = pane.find(
                  '.axtable.available-devices .axtable-content-container .trow[data-id="' + key + '"] .device-password-block');
              const exclamation = $('<i class="fa fa-exclamation-circle error"></i>').attr('data-axtooltip-class', 'error').attr('data-axtooltip', message);
              passwordBlock.find('[name="password"]').addClass('field-error');
              passwordBlock.find('input').after(exclamation);
            });
          }
          if (Object.keys(validationErrors.runbook_password).length > 0) {
            $.each(validationErrors.runbook_password.errors, function (key, message) {
              const errorField = pane.find('.password-container input[name="' + key + '"]');
              const exclamation = $('<i class="fa fa-exclamation-circle error"></i>').attr('data-axtooltip-class', 'error').attr('data-axtooltip', message);
              errorField.find('[name="' + key + '"]').addClass('field-error');
              errorField.find('input').after(exclamation);
            });
          }
          runbookFlow.showErrors(pane.find('.available-devices-container'), validationErrors.items);
          runbookFlow.showErrors(pane.find('.runbook-password-block'), validationErrors.runbook_password);
          validationError();
        };
        RUNBOOK_ACTIONS_MANAGER.items().verify_passwords(validationParams, successFunction, failFunction);
      },
      getDevicesPasswords: function (pane) {
        const items = {};
        pane.find('.axtable.available-devices .axtable-content-container .trow[data-has_password="true"]').has('.selectcell input:checked').each(function () {
          const $row = $(this);
          const index = $row.data('id');
          const password = $row.find('[name="password"]').val();
          items[index] = password;
        });
        return items;
      },
      /**
       * @private
       */
      isSelectionChanged: function(pane) {
        var prevSelection = this.getInitialSelection(pane),
            currentSelection = this.getCurrentSelection(pane);

        if (prevSelection.length !== currentSelection.length) {
          return true;
        } else {
          prevSelection.sort(); currentSelection.sort();
          for (var i = 0; i < prevSelection.length; i++) {
            if (prevSelection[i] != currentSelection[i]) {
              return true;
            }
          }
        }

        return false;
      },
      validateBack: function(pane, data, noDataChanged, dataHasChanged) {
        if (this.isSelectionChanged(pane)) {
          dataHasChanged();
        } else {
          noDataChanged();
        }
      },
      validateNext: function(pane, data, validationSuccess, validationError) {
        this.storeInitialSelection(pane);
        var currentSelection = this.getCurrentSelection(pane);
        const firstDevice = currentSelection[0];
        const stepData = data.steps[this.id];
        if (stepData && stepData.list && stepData.list[firstDevice]) {
          data.runbookGeneration = stepData.list[firstDevice].app_generation;
        }
        var runbookGeneration = data.runbookGeneration,
        params = {
          'client_id': data.client_id,
          'device_ids': currentSelection
        };
        if (data.id) {
          var itemsList = (stepData || {}).list || {};
          $.extend(params, {
            'runbook_id': data.id,
            'selected': itemsList
          });
        }
        if (stepData.password) {
          $.extend(params, {
            'password': stepData.password,
            'confirmPassword': stepData.confirmPassword
          });
        }
        this.verifyProtectedSystems(pane, params, runbookGeneration, validationSuccess, validationError);
      },
      /**
       * Restores device's selection.
       * @private
       */
      restoreDevicesSelection: function(pane, data) {
        let currentGeneration = data.generation !== undefined ? data.generation : data.runbookGeneration;
        let radios = $('input[name="runbook_devices_generation"]');

        if ($('input[name="runbook_devices_generation"]').length) {
          if (currentGeneration == RB_GENERATION) {
            radios.filter('[value="' + RB_GENERATION + '"]').attr('checked', true);
          } else if (currentGeneration == BRC_GENERATION) {
            radios.filter('[value="' + BRC_GENERATION + '"]').attr('checked', true);
          }
        }

        pane.find('.trow.js-filtered').each(function () {
          if ($(this).data('app_generation') == currentGeneration) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });

        var devicesList = (data.steps[this.id] || {}).list || {},
            deletedDevices = (data.steps[this.id] || {}).delete || {};

        pane.find('.trow[data-id]').each(function (i, el) {
          var $el = $(el),
              deviceId = $el.data('id'),

              isRunbookItem = $el.is('[data-runbook_item_id]'),

              isSelected = (typeof devicesList[deviceId] !== 'undefined'),
              isDeleted = (typeof deletedDevices[deviceId] !== 'undefined'),

              checkbox = $el.find('.selectcell input'),
              checkboxIsChecked = checkbox.is(':checked'),

              shouldBeChecked = (isRunbookItem || isSelected) && !isDeleted,
              shouldBeUnchecked = isDeleted;

          if ((shouldBeChecked && !checkboxIsChecked) ||
              (shouldBeUnchecked && checkboxIsChecked)) {
            checkbox.click();
          }
          if (isSelected && devicesList[deviceId].has_password) {
            $el.find('[name="password"]').val(devicesList[deviceId].password);
          }
        });

        this.storeInitialSelection(pane);
      },
      beforePaneLoad: function(pane, data) {
        var selectDevicesOptions = this;

        pane.off('click', '.select_all:not(.disabled)')
            .on('click', '.select_all:not(.disabled)', function() {
                  pane.find('.trow[data-rel_app]:not(.non-virtualizable-device):visible input:not(:checked)').click();
                  selectDevicesOptions.updateBtnsState(pane, data);
                });
        pane.off('click', '.deselect_all:not(.disabled)')
            .on('click', '.deselect_all:not(.disabled)', function() {
                  pane.find('.trow[data-rel_app] input:checked').click();
                  selectDevicesOptions.updateBtnsState(pane, data);
                });

        pane.off('change', '.trow .selectcell input')
            .on('change', '.trow .selectcell input', function() {
                  var selected = pane.find('.trow[data-id] .selectcell input:checked');

                  pane.find('.loweramount.plural').attr('data-amount', selected.length)
                                                  .find('.total').html(selected.length);
                  selectDevicesOptions.updateBtnsState(pane, data);
                });
        pane.off('data-fetched', '.available-devices')
            .on('data-fetched', '.available-devices', function() {
              selectDevicesOptions.restoreDevicesSelection(pane, data);
              selectDevicesOptions.updateBtnsState(pane, data);
            });
      },
      updateBtnsState: function(pane, data) {
        var next = pane.find(nextBtn),
            finish = pane.find(finishBtn),
            selectAll = pane.find('.select_all'),
            deselectAll = pane.find('.deselect_all'),
            devices = pane.find('.trow[data-id]'),
            allLength = devices.length,
            selectedLength = devices.find('.selectcell input:checked').length;

        pane.find(btnsSelector).removeClass('disabled');

        if (allLength === 0) {
          next.addClass('disabled');
          finish.addClass('disabled');
          selectAll.addClass('disabled');
          deselectAll.addClass('disabled');
        } else if (selectedLength === 0) {
          next.addClass('disabled');
          finish.addClass('disabled');
          selectAll.removeClass('disabled');
          deselectAll.addClass('disabled');
        } else if (selectedLength === allLength) {
          next.removeClass('disabled');
          finish.removeClass('disabled');
          selectAll.addClass('disabled');
          deselectAll.removeClass('disabled');
        } else {
          next.removeClass('disabled');
          finish.removeClass('disabled');
          selectAll.removeClass('disabled');
          deselectAll.removeClass('disabled');
        }
      }
    },
    // step3
    {
      id: 'step3',
      view: 'values',
      save: function(data, saveSuccess, saveFailed) {
        var itemsListDataKey = 'step2',
            itemsList = (data.steps[itemsListDataKey] || {}).list || {},
            itemsValues = data.steps[this.id] || {},
            updateItems = {};
        $.each(itemsList, function(deviceId, item) {
          if (typeof item.runbook_item_id === 'undefined') { return true; }

          var itemToUpdate = {},
              deviceValues = itemsValues[deviceId] || {};

          if ($.isEmptyObject(deviceValues)) { return true; }

          itemToUpdate.runbook_item_id = item.runbook_item_id;
          itemToUpdate.cores = deviceValues.cores || 2;
          itemToUpdate.ram = deviceValues.ram || 4;
          itemToUpdate.priority = deviceValues.priority || 'MEDIUM';
          itemToUpdate.wait_time = deviceValues.wait_time || 0;
          itemToUpdate.safe_boot = getSafeBootValue([deviceValues.safe_boot], item.safe_boot_enabled);
          itemToUpdate.ip_address = deviceValues.ip_address || deviceValues.device_ip_address;
          updateItems[deviceId] = itemToUpdate;
        });
        if ($.isEmptyObject(updateItems)) {
          saveSuccess();
          return;
        }
        var params = {
              'client_id': data.client_id,
              'runbook_id': data.id || 0,
              'update_items': updateItems
            };
        RUNBOOK_ACTIONS_MANAGER.items().update(params, saveSuccess, saveFailed);
      },
      validateNext: function(pane, data, validationSuccess, validationError) {
        if (isHotsiteRunbookGeneration(data.runbookGeneration)) {
          pane.data('has_changed', false);
          if (data.runbookGeneration === BRC_GENERATION) {
            this.ajaxCheckResources(pane, data, validationSuccess, (validationErrors) => {
              validationError();
              runbookFlow.showErrors(pane, validationErrors);
            });
          } else {
            validationSuccess();
          }
        } else {
          throwUnknownRunbookTypeError(data.runbookGeneration);
        }
      },
      /**
       * Returns all currently selected devices.
       * @private
       */
      devicesList: function(data) {
        var itemsListDataKey = 'step2',
            items = (data.steps[itemsListDataKey] || {}).list || {},
            itemsUpdate = data.steps[this.id] || {},
            response = [];
        $.each(items, function(deviceId, itemData) {
          var updated = itemsUpdate[deviceId] || {};
          var item = {
            'rowAttr': {
              'id': deviceId,
              'name': itemData.display_name,
              'runbook_item_id': itemData.runbook_item_id,
              'client_id': itemData.client_id,
              'priority': updated.priority || itemData.priority,
              'os_bits': itemData.os_bits,
              'max_cores': itemData.max_cores || 16,
              'max_ram': itemData.max_ram || 32,
              'cores': updated.cores || itemData.cores,
              'ram': updated.ram || itemData.ram,
              'wait_time': updated.wait_time || itemData.wait_time,
              'ip_address': updated.ip_address || itemData.ip_address || itemData.device_ip_address,
              'device_ip_address': itemData.device_ip_address,
              'safe_boot': getSafeBootValue([updated.safe_boot, itemData.safe_boot], updated.safe_boot_enabled || itemData.safe_boot_enabled),
              'safe_boot_enabled': itemData.safe_boot_enabled
            },
            'rowData': {}
          };

          let rowDataExtension = {
            display_name : itemData.display_name,
            service_name : (isHotsiteRunbookGeneration(itemData.app_generation)) ? itemData.service_name : undefined,
            priority : (updated.priority || itemData.priority).toLowerCase(),
            cores : updated.cores || itemData.cores,
            ram : updated.ram || itemData.ram,
            wait_time : updated.wait_time || itemData.wait_time,
            safe_boot: !itemData.safe_boot_enabled ? 'N/A' : getSafeBootValue([updated.safe_boot, itemData.safe_boot], itemData.safe_boot_enabled) ? 'Yes' : 'No'
          }

          $.extend(item.rowData, rowDataExtension);
          response.push(item);
        });

        return response;
      },
      /**
       * Shows edit dialog.
       * @private
       */
      showEditDialog: function(pane, data) {
        var self = this,
            rbId = data.id,
            selectedItems = pane.find('.axtable.runbook-items .trow')
                                .has('.selectcell input:checked')
                                .map(function(i, el) {
                                  const elData = $(el).data();
                                  let resultData = {
                                    'name': elData.name,
                                    'device_id': elData.id,
                                    'runbook_item_id': elData.runbook_item_id,
                                    'os_bits': elData.os_bits,
                                    'max_cores': elData.max_cores,
                                    'max_ram': elData.max_ram,
                                    'cores': elData.cores,
                                    'ram': elData.ram,
                                    'priority': elData.priority,
                                    'wait_time': elData.wait_time,
                                    'ip_address': elData.ip_address || elData.device_ip_address,
                                    'device_ip_address': elData.device_ip_address,
                                    'safe_boot': elData.safe_boot,
                                    'safe_boot_enabled': elData.safe_boot_enabled
                                  };
                                  return resultData;
                                }).toArray(),

            disablePane = function() {
              pane.find('.edit-btn').addClass('disabled');
              pane.addClass('disabled');
            },
            enablePane = function() {
              pane.find('.edit-btn').removeClass('disabled');
              pane.removeClass('disabled');
            },
            switchSafeBoot = function(dlg, isEnabled) {
              const safeBootRow = dlg.find('.js-safe-boot-row');
              if (isEnabled) {
                safeBootRow.show();
                const safeBoot = dlg.find('#safe_boot');
                if (safeBoot.length) {
                  emulateCheck(safeBoot.attr('id'));
                  safeBoot.click(function (event) {
                    emulateCheck(event.currentTarget.id);
                  });
                }
              } else {
                safeBootRow.hide();
              }
            },
            isSafeBootEnabled = function(items) {
              for (item of items) {
                if (!item['safe_boot_enabled']) {
                  return false;
                }
              }
              return true;
            },

            storeValues = function(dlg) {
              data.steps[self.id] = data.steps[self.id] || {};
              var values = {},
                  isMultipleSelection = selectedItems.length > 1;

              dlg.find('select, input').each(function(i, sel) {
                var fld = $(sel),
                    name = fld.prop('name'),
                    isCheckbox = fld.is(':checkbox'),
                    val = isCheckbox ? +fld.is(':checked') : fld.val();
                values[name] = val;
              });

              $.each(selectedItems, function(i, item) {
                var ipAddress = isMultipleSelection ? item.ip_address : values.failover_ip_address;
                let itemData = {
                  cores: values.cores || item.cores,
                  ram: values.ram || item.ram,
                  priority: values.priority || item.priority,
                  wait_time: values.wait_time || item.wait_time,
                  ip_address: ipAddress,
                  safe_boot: getSafeBootValue([values.safe_boot, item.safe_boot], values.safe_boot_enabled || item.safe_boot_enabled)
                };
                data.steps[self.id][item.device_id] = itemData;
              });
            },
            handleMultipleSelection = function(dlg, values) {
              if (selectedItems.length > 1) {
                dlg.find('.edit_item:last-of-type').addClass('disabled');
                dlg.find('.edit-runbook-values-dlg').data('skip_validation', true);
                delete values.failover_ip_address;
                dlg.find('[name="failover_ip_address"]').removeData('device_ip_address');
              } else {
                dlg.find('[name="failover_ip_address"]').data('device_ip_address', selectedItems[0].device_ip_address);
              }
            },
            prepareDlgValues = function(dlg) {
              var x32 = 32,
                  valuesKeyMap = {
                    'priority': 'priority',
                    'cores': 'cores',
                    'ram': 'ram',
                    'wait_time': 'wait_time',
                    'safe_boot': 'safe_boot',
                  },
                  values = {
                    'priority': null,
                    'cores': null,
                    'ram': null,
                    'wait_time': null,
                    'safe_boot': null,
                  },
                  maxRamVal = Math.min.apply(Math, selectedItems.map(function(el) {
                                                                       return el.max_ram;
                                                                     })),
                  maxCoresVal = Math.min.apply(Math, selectedItems.map(function(el) {
                                                                         return el.max_cores;
                                                                       })),
                  hasX32Device = selectedItems.map(function(el) {
                                                     return el.os_bits;
                                                   }).indexOf(x32) !== -1;
              $.each(selectedItems, function(i, item) {
                for (var k in values) {
                  var itemKey = valuesKeyMap[k],
                      itemVal = item[itemKey];
                  if (values[k] === null) {
                    values[k] = itemVal;
                  } else if (values[k] != itemVal) {
                    values[k] = '';
                  }
                }
              });

              handleMultipleSelection(dlg, values);

              dlg.find('[name="cores"]').data('max', maxCoresVal);
              dlg.find('[name="ram"]').data('max', maxRamVal);
              dlg.find('.edit-runbook-values-dlg').data(
                {'has_x32': hasX32Device, 'values': values}
              );
              dlg.find('.edit-runbook-values-dlg').trigger('set-values');
            },
            prepareDlgTitle = function(dlg) {
              var headerText,
                  headerContainer = dlg.find('#edit_values_tabs .header');
              if (selectedItems.length === 1) {
                headerText = selectedItems[0].name + ' ' + _is_selected;
              } else {
                headerText = selectedItems.length + ' ' + _devices_selected;
              }
              headerContainer.html(headerText);
            },
            afterDlgCreate = function(dlg) {
              enablePane();
              prepareDlgTitle(dlg);
              prepareDlgValues(dlg);
              switchSafeBoot(dlg, isSafeBootEnabled(selectedItems));
            },
            saveFunction = function(dlg) {
              if (dlg.find('.js-vm-cpu-amount input').valid() && dlg.find('.js-vm-ram-amount input').valid()) {
                storeValues(dlg);
                pane.find('.axtable.runbook-items').data('ax-axTable').reset();
                self.updateResources(pane);
                self.localCheckResources(pane, data);

                return true;
              }

              return false;
            };

        disablePane();
        RUNBOOK_DIALOGS.showEditValuesDialog(rbId, data.runbookGeneration, afterDlgCreate, saveFunction);
      },
      beforePaneLoad: function(pane, data) {
        var self = this,
            onTableDataDemand = function() {
              pane.find('.axtable.runbook-items').data('items', self.devicesList(data) || []);
            },
            showEditDialog = function() {
              self.showEditDialog(pane, data);
            },
            updateEditBtn = function() { self.updateBtnsState(pane, data); };
        pane.off('data-demand', '*', onTableDataDemand).on('data-demand', '*', onTableDataDemand);
        pane.off('change', '.selectcell input').on('change', '.selectcell input', updateEditBtn);
        pane.off('click', '.edit-btn:not(.disabled)').on('click', '.edit-btn:not(.disabled)', showEditDialog);
      },
      afterPaneLoad: function(pane, data) {
        var self = this;
        if (data.id) {
          this.localCheckResources(pane, data);
        } else {
          var failFunction = function(validationErrors) {
						var requestParams = {
									items: self.getItemsWithResources(pane),
									client_id: data.client_id,
									generation: data.runbookGeneration
							},
              getSuccess = function(assignedValues) {
                var items = self.devicesList(data) || [],
                  ids = items
                    .map(function(row) {
                      return row.rowAttr || []; })
                    .map(function(i) {
                      return i.id});
                data.steps[self.id] = data.steps[self.id] || {};
                ids.forEach(function(id) {
                  data.steps[self.id][id] = data.steps[self.id][id] || {};
                  $.extend(data.steps[self.id][id], assignedValues.data);
                });
                pane.find('.axtable.runbook-items').data('ax-axTable').reset();
                self.updateResources(pane);
                self.localCheckResources(pane, data);
              };

            RUNBOOK_ACTIONS_MANAGER.items().get_resources(requestParams, getSuccess, function(errors) {});
          };
          this.localCheckResources(pane, data, failFunction);
        }
      },
      updateBtnsState: function(pane) {
        this.updateResources(pane);
        if (pane.find('.axtable.runbook-items .trow')
                .has('.selectcell input:checked').length === 0) {
          pane.find('.edit-btn').addClass('disabled');
        } else {
          pane.find('.edit-btn').removeClass('disabled');
        }
      },
      getResourcesUsage: function(pane) {
        var result = {
            maxRam: pane.find('.js-max-ram').data('max_ram'),
            maxCpu: pane.find('.js-max-cpu').data('max_cpu'),
            ramUsage: 0,
            cpuUsage: 0
          };
        pane.find('.axtable.runbook-items .axtable-content-container .trow').each(function(){
          var row = $(this);
          result.ramUsage += parseInt(row.data('ram'));
          result.cpuUsage += parseInt(row.data('cores'));
        });
        result.isUsageNotExceeded = result.ramUsage <= result.maxRam && result.cpuUsage <= result.maxCpu;
        return result;
      },
      updateResources: function(pane) {
        var resourcesBlock = pane.find('.section.cc-resources');
        if(resourcesBlock.length === 0) {
          return;
        }
        var resourcesUsage = this.getResourcesUsage(pane),
            ramUsagePercent = 0,
            cpuUsagePercent = 0;
        ramUsagePercent = resourcesUsage.ramUsage * 100 / resourcesUsage.maxRam;
        cpuUsagePercent = resourcesUsage.cpuUsage * 100 / resourcesUsage.maxCpu;
        resourcesBlock.find('.ram .used').text(resourcesUsage.ramUsage);
        resourcesBlock.find('.cpu .used').text(resourcesUsage.cpuUsage);
        resourcesBlock.find('.progress-ram').width(ramUsagePercent + '%');
        resourcesBlock.find('.progress-cpu').width(cpuUsagePercent + '%');
      },
      getItemsWithResources: function(pane) {
        var items = {};
        pane.find('.axtable.runbook-items  .axtable-content-container .trow').each(function () {
          var $row = $(this),
            index = $row.data('id'),
            ram = $row.data('ram'),
            cores = $row.data('cores');
          items[index] = {
            ram: ram,
            cores: cores
          }
        });
        return items;
      },
      ajaxCheckResources: function(pane, data, success, fail) {
        if (data.runbookGeneration === BRC_GENERATION) {
					var validationParams = {
								items: this.getItemsWithResources(pane),
								client_id: data.client_id,
								generation: data.runbookGeneration
						},
            successFunction = success || function(){
              runbookFlow.clearErrors(pane);
            },
            failFunction = fail || function(validationErrors){
              runbookFlow.showErrors(pane, validationErrors);
            };
          RUNBOOK_ACTIONS_MANAGER.items().check_resources(validationParams, successFunction, failFunction);
        }
      },
      localCheckResources: function(pane, data, fail) {
        if (data.runbookGeneration === BRC_GENERATION) {
          var failFunction = fail || function(validationErrors){
              runbookFlow.showErrors(pane, validationErrors);
            },
            resourcesUsage = this.getResourcesUsage(pane),
            validationErrors = {
              title: _warning_reached_resources_label,
              details: ''
            };
          if (resourcesUsage.isUsageNotExceeded) {
            runbookFlow.clearErrors(pane);
          } else {
            failFunction(validationErrors);
          }
        }
      }
    },
    // step4
    {
      id: 'step4',
      view: 'network',
      save: function(data, saveSuccess, saveFailed) {
        var self = this,
            settings = data.steps[this.id] || {};

        if ($.isEmptyObject(settings)) {
          saveSuccess();
          return;
        }

        var saveSuccessCallback = function(response) {
              saveSuccess(response);
            },
            saveFailedCallback = function(response) {
              saveFailed(response);
            };

        var params = {
          'client_id': data.client_id,
          'runbook_id': data.id || 0,
          'network_settings': settings,
          'generation' : data.runbookGeneration,
        };

        RUNBOOK_ACTIONS_MANAGER.network().save(params, saveSuccessCallback, saveFailedCallback);
      },
      collect: function(pane) {
        var settings = {
          subnets: {
            add   : {},
            stored: {},
            delete: {}
          }
        };
        if (isHotsiteRunbookGeneration(this.runbookGeneration)) {
          settings.vnc_ip = pane.find('input[name=vnc_ip]').val();
          settings.internet_on = pane.find('input[name=outbound_access]').is(':checked');
        } else {
          throwUnknownRunbookTypeError(this.runbookGeneration);
        }

        pane.find('.axtable.hotsite-subnet-list .js-subnet:not(.js-template)').each(function() {
          var row = $(this),
           isNew = row.is('.new'),
           isVisible = row.is(':visible'),
           isDeleted = row.is('.edited') || row.is('.deleted'),
           item, index;

          if (isNew) {
            index = get_row_index(row);
            item = row_to_object(row);
            settings.subnets.add[index] = item;
          } else if (isDeleted) {
            item = index = row.data('subnet_id');
            settings.subnets.delete[index] = item;
          } else if (isVisible) {
            item = {
              subnet_gateway: row.find('[data-name="subnet_gateway"]').text(),
              subnet_netmask: row.find('[data-name="subnet_netmask"]').text()
            };
            index = row.data('subnet_id');
            settings.subnets.stored[index] = item;
          }
        });

        return settings;
      },
      validateBack: function(pane, data, noDataChanged, dataHasChanged) {
        if (pane.data('has_changed')) {
          dataHasChanged();
        } else {
          noDataChanged();
        }
      },
      validateNext: function(pane, data, validationSuccess, validationError, validationErrorPrev) {
        pane.data('has_changed', false);

        var validationParams = {
              'client_id': data.client_id,
              'network_settings': data.steps[this.id],
              'generation': data.runbookGeneration,
            },
            success = function() {
              validationSuccess();
            },
            fail = function(validationErrors) {
              validationErrors = validationErrors || {};

              if (data.id) {
                $.extend(validationParams, {'runbook_id': data.id});
              }
              validationError();
              runbookFlow.showErrors(pane, validationErrors);
            };

        RUNBOOK_ACTIONS_MANAGER.network().validate(validationParams, success, fail);
      },
      beforePaneLoad: function(pane) {
        pane.off('change', ':input');
        pane.off('click', '.add-more, .js-subnet .fa-trash-o, .js-subnet .fa-undo');
      },
      afterPaneLoad: function(pane, data) {
        var self = this,
            settings = data.steps[this.id] || {},
            gateway = settings.gateway_ip || '',
            netmask = settings.netmask || '',
            outboundAccess = settings.internet_on,
            vncIp = settings.vnc_ip || '',
            subnets = (settings.subnets || {}).add || {},
            deleteSubnets = (settings.subnets || {}).delete || {};
        self.runbookGeneration = data.runbookGeneration;

        if (gateway) {
          pane.find('input[name=vo_gateway_ip]').val(gateway);
        }
        if (netmask) {
          pane.find('input[name=vo_netmask]').val(netmask);
        }

        if(outboundAccess !== undefined) {
          pane.find('[name=outbound_access]').prop('checked', outboundAccess).change();
        }

        if (vncIp) {
          pane.find('input[name=vnc_ip]').val(vncIp);
        }

        $.each(deleteSubnets, function (i) {
          var selector = '.js-subnet[data-subnet_id="' + i + '"] .fa-trash-o';
          pane.find(selector).click();
        });
        $.each(subnets, function(i, subnet) {
          pane.find('#addmore a').click();
          var newSubnetRecord = pane.find('.js-subnet:visible:last');
          newSubnetRecord.find('.subnet_gateway input').val(subnet.subnet_gateway || '');
          newSubnetRecord.find('.subnet_netmask input').val(subnet.subnet_netmask || '');
          newSubnetRecord.find('.subnet_internet_on input').prop('checked', subnet.internet_on || false);
        });

        pane.find('> div').trigger('data-restored');

        pane.data('has_changed', false);
        pane.on('change', ':input', function() { pane.data('has_changed', true); });
        pane.on('click', '.add-more, .js-subnet .fa-trash-o, .js-subnet .fa-undo', function() { pane.data('has_changed', true); });
      }
    },
    // step5
    {
      id: 'step5',
      view: 'advanced',

      setValueToFieldName: function(pane, fieldName, value) {
        if(value) {
          pane.find('[name=' + fieldName + ']').val(value || '');
        }
      },
      /**
       * Restores VPN settings for Hotsite runbook
       * @private
       */
      restoreHotsiteVPN: function(pane, vpnData) {
        var enabled = vpnData.vpn_enabled || false,
         vlanIp = vpnData.vlan_ip || '',
				 virtualSubnet = vpnData.virtual_subnet || '',
         splitTunneling = vpnData.split_tunneling || '',
         userParameterType = vpnData.user_parameter_type || '',
         ipRangeStart = vpnData.iprange_start || '',
         ipRangeEnd = vpnData.iprange_end || '',
         dns = vpnData.dns || {},
         adConfig = vpnData.ad_config || {},
         users = vpnData.users || {},
         addUsers = users.add || {},
         deleteUsers = users.delete || {};

        if (enabled) {
          pane.find('[name=vpn_enabled]').prop('checked', !!enabled).change();
        }
        if (splitTunneling) {
          pane.find('[name=split_tunneling]').prop('checked', !!splitTunneling).change();
        }

        this.setValueToFieldName(pane, 'vlan_ip', vlanIp);
				this.setValueToFieldName(pane, 'virtual_subnet', virtualSubnet);
        this.setValueToFieldName(pane, 'iprange_start', ipRangeStart);
        this.setValueToFieldName(pane, 'iprange_end', ipRangeEnd);
        this.setValueToFieldName(pane, 'vpn_dns_domain', dns.vpn_dns_domain);
        this.setValueToFieldName(pane, 'vpn_primary_dns_ip', dns.vpn_primary_dns_ip);
        this.setValueToFieldName(pane, 'vpn_secondary_dns_ip', dns.vpn_secondary_dns_ip);

        if(userParameterType){
          pane.find('.auth_method_type').attr('data-method', userParameterType);
          var $authMethod = pane.find('#auth_method_'+userParameterType.toLowerCase());
          $authMethod.prop('checked', true);
          if(userParameterType === 'AD') {
            this.setValueToFieldName(pane, 'ip', adConfig.ip);
            this.setValueToFieldName(pane, 'domain', adConfig.domain);
            this.setValueToFieldName(pane, 'admin_name', adConfig.admin_name);
            this.setValueToFieldName(pane, 'admin_password', adConfig.admin_password);
            pane.find('[name=connection_type_value]').attr('data-secure', adConfig.connection_type);
            pane.find('#type_'+adConfig.connection_type).prop('checked', true);
            $authMethod.click();
          } else {
            $authMethod.click();
            $.each(deleteUsers, function(i, user) {
              pane.find('.js-vpn.trow[data-user="'+user+'"] .fa-trash-o').click();
            });
            $.each(addUsers, function(i, user) {
              pane.find('.js-add-vpn a').click();
              var newVPNRecord = pane.find('.js-vpn.trow:visible:last');
              newVPNRecord.find('input.username').val(user.username || '');
              newVPNRecord.find('input.password').val(user.password || '');
            });
          }
        }
      },
      /**
       * Restores PF settings for Hotsite runbook.
       * @private
       */
      restoreHotsitePF: function(pane, pfData) {
        var enabled = pfData.port_forward_enabled,
         interfaces = pfData.pf_interfaces || [];

        if (enabled !== undefined) {
          pane.find('[name=pf_enabled]').prop('checked', !!enabled).change();
        }

        $.each(interfaces, function(index, interf){
          var addRules = interf.add || {},
           deleteRules = interf.delete || {};
          $.each(deleteRules, function(i, ruleId) {
            pane.find('.hotsite_port_fwd_rules[data-ip_num="'+index+'"] .js-pf.trow[data-pf_rule="'+ruleId+'"] .fa-trash-o').click();
          });
          $.each(addRules, function(i, rule) {
            pane.find('.hotsite_port_fwd_rules[data-ip_num="'+index+'"] .js-add-pf a').click();
            var newPFRecord = pane.find('.hotsite_port_fwd_rules[data-ip_num="'+index+'"] .js-pf.trow:visible:last');
            newPFRecord.find('.ext_port input').val(rule.ext_port || '');
            newPFRecord.find('.int_ip input').val(rule.int_ip || '');
            newPFRecord.find('.int_port input').val(rule.int_port || '');
          });
        });
      },
      /**
       * Restores DHCP settings for Hotsite runbook.
       * @private
       */
      restoreHotsiteDHCP: function(pane, dhcpData) {
        var enabled = dhcpData.dhcp_enabled,
         domain = dhcpData.domain || '',
         rangeStart = dhcpData.range_start || '',
         rangeEnd = dhcpData.range_end || '',
         dnsServers = dhcpData.dns_servers || {},
         macToIp = dhcpData.mac_to_ip || {};

        if (enabled !== undefined) {
          pane.find('[name=dhcp_enabled]').prop('checked', !!enabled).change();
        }

        $.each(dnsServers, function(i, dns) {
          var dnsField = pane.find('[name="dns_server['+i+']"]');
          if(dnsField.length === 0){
            pane.find('.adddns a').click();
            dnsField = pane.find('[name="dns_server['+i+']"]');
          }
          dnsField.val(dns.dns_server);
        });
        var dnsDeleted = pane.find('.dns_list .row').length - Object.keys(dnsServers).length;
        if(Object.keys(dnsServers) && dnsDeleted){
          pane.find('.dns_list .row:gt(' + (dnsDeleted-1) +')').remove();
        }

        $.each(macToIp, function(i, mac2ip) {
          var macField = pane.find('[name="mac['+i+']"]'),
           ipField = pane.find('[name="ip['+i+']"]');
          if(macField.length === 0 && ipField.length === 0){
            pane.find('.addmac2ip a').click();
            macField = pane.find('[name="mac['+i+']"]');
            ipField = pane.find('[name="ip['+i+']"]');
          }
          macField.val(mac2ip.mac);
          ipField.val(mac2ip.ip);
        });
        var macsDeleted = pane.find('.mac2ip_list .row').length - Object.keys(macToIp).length;
        if(Object.keys(macToIp).length && macsDeleted){
          pane.find('.mac2ip_list .row:gt(' + (macsDeleted-1) +')').remove();
        }

        this.setValueToFieldName(pane, 'domain', domain);
        this.setValueToFieldName(pane, 'range_start', rangeStart);
        this.setValueToFieldName(pane, 'range_end', rangeEnd);

      },
      /**
       * Restores S2S settings for Hotsite runbook.
       * @private
       */
      restoreHotsiteS2S: function(pane, s2sData) {
        var enabled = s2sData.s2s_vpn_enabled,
         allowedIps = s2sData.allowed_ips || {},
         endpoint = s2sData.endpoint || {},
         configType = endpoint.config_type || false;

        if (enabled !== undefined) {
          pane.find('[name=s2s_vpn_enabled]').prop('checked', !!enabled).change();
        }

        $.each(allowedIps, function(i, allowedIp) {
          var ipField = pane.find('[name="allowed_ip['+i+']"]');
          if(ipField.length == 0){
            pane.find('.addip a').click();
            ipField = pane.find('[name="allowed_ip['+i+']"]');
          }
          ipField.val(allowedIp.allowed_ip);
        });
        var ipsDeleted = pane.find('.allowed_ips_list .row').length - Object.keys(allowedIps).length;
        if(Object.keys(allowedIps) && ipsDeleted){
          pane.find('.allowed_ips_list .row:gt(' + (ipsDeleted-1) +')').remove();
        }

        if(configType){
          pane.find('.config-type').attr('data-config', configType);
          pane.find('#config_'+configType).prop('checked', true);
        }

        this.setValueToFieldName(pane, 'endpoint_name', endpoint.endpoint_name);
        this.setValueToFieldName(pane, 'key_password', endpoint.key_password);
        this.setValueToFieldName(pane, 'gateway', endpoint.gateway);
        this.setValueToFieldName(pane, 'netmask', endpoint.netmask);
        this.setValueToFieldName(pane, 'endpoint_ip', endpoint.endpoint_ip);
        this.setValueToFieldName(pane, 'dns', endpoint.dns);

      },
      /**
       * Restores S2S IPSec settings for Hotsite runbook.
       * @private
       */
      restoreHotsiteS2SIpSec: function(pane, ipSecData) {
        const enabled = ipSecData.s2s_ipsec_enabled;
        const localIdentifierType = (ipSecData.local_ipsec_id || {}).local_identifier_type;
        const remoteSites = (ipSecData.remote_sites || {});
        const remoteSitesCount = Object.keys(remoteSites).length;

        // Fill common fields
        if(enabled !== undefined) {
          pane.find('[name=s2s_ipsec_enabled]').prop('checked', !!enabled).change();
        }
        if (localIdentifierType === 'ip') {
          pane.find('input[name="local-id"][value="ip"]').prop('checked', true).click();
        } else {
          pane.find('input[name="local-id"][value="name"]').prop('checked', true).click();
          pane.find('input[name="local-name"]').val((ipSecData.local_ipsec_id || {}).local_identifier_name);
        }

        // Removing created sites with data from DB (s2sipsec_site.php)
        // The first one is needed to create the next ones.
        pane.find('.js-delete-site:not(:first)').click();

        // Create empty remote sites for restore
        if (remoteSitesCount > 1) {
          for (let i=0; i<remoteSitesCount-1; i++) {
            pane.find('.add-more a').click();
          }
        }

        // Fill remote sites
        for (const [key, remoteSite] of Object.entries(remoteSites)) {
          pane.find('.js-site-id[data-num="' + key + '"] .ipsec-title span').text(remoteSite.name);
          pane.find('.site-name [name="name[' + key.toString() +']"]').val(remoteSite.name);
          pane.find('.public-ip [name="public_ip[' + key.toString() +']"]').val(remoteSite.public_ip);
          if (remoteSite.remote_type === 'ip') {
            pane.find('.remote-ip input[name="remote-id[' + key.toString() +']"]').prop('checked', true).click();
            pane.find('.remote-ip input[name="remote_ip[' + key.toString() +']"]').val(remoteSite.remote_ip);
          } else {
            pane.find('.remote-name input[name="remote-id[' + key.toString() +']"]').prop('checked', true).click();
            pane.find('.remote-name input[name="remote_name[' + key.toString() +']"]').val(remoteSite.remote_name);
          }
          const items = [];
          for(let subnet of remoteSite.remote_subnets) {
            items.push({id: subnet, name: subnet});
          }
          // Clean tockenfield before recreating new one
          pane.find('.js-site-id[data-num="' + key + '"] .remote-subnets').children().remove();
          pane.find('.js-site-id[data-num="' + key + '"] .remote-subnets').append(
              '<input type="text" data-name="advanced_settings[s2s_ipsec][remote_sites][' + key + '][remote_subnets]" name="remote_subnets[' + key + ']" class="edit_field size_long js-remote-subnets-tokenfield"' +
              '<div class="clear_left"></div>');

          const runbookSectionSelector = '#'+ pane.parents('.js-runbook-section').attr('id');
          createTokenFieldS2SIPSec(runbookSectionSelector + ' .ipsec-site.record[data-num="' + key + '"] .js-remote-subnets-tokenfield',
              items,
              'remote_subnets[' + key + ']'
          );
        }
      },
      beforePaneLoad: function(pane, data) {
        var self = this;

        pane.off('change', ':input');
        pane.off('click', '.fa-trash-o, .fa-undo');

        pane.off('click', '.fa-trash-o, .add-more, .pf_enabled, .fa-undo')
            .on('click', '.fa-trash-o, .add-more, .pf_enabled, .fa-undo', function() {
          if ($(this).parents('.port_fwd_edit_form').length !== 0) {
            self.updateBtnsState(pane, data);
          }
        });
      },
      afterPaneLoad: function(pane, data) {
        var self = this,
            advancedSettings = data.steps[self.id] || {},
            vpn = advancedSettings.vpn || {},
            pf = advancedSettings.pf || {},
            s2s = advancedSettings.s2s_vpn || {},
            s2sIpSec = advancedSettings.s2s_ipsec || {},
            dhcp = advancedSettings.dhcp || {};
        self.runbookGeneration = data.runbookGeneration;

        if (isHotsiteRunbookGeneration(self.runbookGeneration)) {
          this.restoreHotsiteVPN(pane, vpn);
          this.restoreHotsitePF(pane, pf);
          this.restoreHotsiteDHCP(pane, dhcp);
          this.restoreHotsiteS2S(pane, s2s);
          if (!$.isEmptyObject(s2sIpSec)) {
            this.restoreHotsiteS2SIpSec(pane, s2sIpSec);
          }
        } else {
          throwUnknownRunbookTypeError(self.runbookGeneration);
        }

        pane.find('> div').trigger('data-restored');

        pane.data('has_changed', false);
        pane.on('change', ':input', function() { pane.data('has_changed', true); });
        pane.on('click', '.fa-trash-o, .fa-undo', function() { pane.data('has_changed', true); });
      },

      save: function(data, saveSuccess, saveFail) {
        var self = this,
            settings = data.steps[this.id] || {},
            vpn =  settings.vpn || {},
            pf = settings.pf || {},
            s2s = settings.s2s_vpn || {},
            s2sIpSec = settings.s2s_ipsec || {},
            dhcp = settings.dhcp || {};

        if ($.isEmptyObject(vpn) &&
            $.isEmptyObject(pf) &&
            $.isEmptyObject(s2s) &&
            $.isEmptyObject(dhcp) &&
            $.isEmptyObject(s2sIpSec)) {
          saveSuccess();
          return;
        }

        var commonParams = {
              'client_id': data.client_id,
              'runbook_id': data.id || 0,
              'advanced_settings': {},
              'generation': data.runbookGeneration
            },
            vpnParams = {
              'advanced_settings': {
                'vpn': vpn
              }
            },
            pfParams = {
              'advanced_settings': {
                'pf': pf
              }
            },
            s2sParams = {
              'advanced_settings': {
                's2s_vpn': s2s
              }
            },
            s2sIpSecParams = {
              'advanced_settings': {
                's2s_ipsec': s2sIpSec
              }
            },
            dhcpParams = {
              'advanced_settings': {
                'dhcp': dhcp
              }
            };

        var saveSuccessCallback = function (response) {
            saveSuccess(response);
        },
        saveFailCallback = function (response) {
          saveFail(response);
        };

        if (isHotsiteRunbookGeneration(data.runbookGeneration)) {
          var validationSettings = {
						'device_ids' : Object.keys(data.steps["step2"].list) || [],
            'network_settings' : data.steps['step4'],
            'advanced_settings' : {
              'vpn' : vpnParams.advanced_settings.vpn,
              'port_forward' : pfParams.advanced_settings.pf,
              'dhcp' : dhcpParams.advanced_settings.dhcp,
              's2s_vpn' : s2sParams.advanced_settings.s2s_vpn,
              's2s_ipsec' : s2sIpSecParams.advanced_settings.s2s_ipsec
            }
          };
          RUNBOOK_ACTIONS_MANAGER.hotsiteAdvanced().save($.extend(commonParams, validationSettings), saveSuccessCallback, saveFailCallback);
        } else {
          throwUnknownRunbookTypeError(data.runbookGeneration);
        }

      },
      /**
       * Collects VPN data for Hotsite runbook
       * @private
       */
      collectHotsiteVPN: function(pane) {
        var addSettingValue = function(field, setting){
          var name = field.attr('name'),
           val = field.val();
          setting[name] = val;
        };

        var vpnForm = pane.find('.vpn_edit_form'),
         authType = vpnForm.find('.auth_method_type').attr('data-method');
         settings = {
           vpn_enabled: false,
           openvpn_enabled: false,
           user_parameter_type: authType,
           users: {
             add: {},
             stored: {},
             delete: {}
           },
           dns: { },
           ad_config: { }
         };

        settings.vpn_enabled = settings.openvpn_enabled = vpnForm.find('[name=vpn_enabled]').is(':checked');
        settings.split_tunneling = vpnForm.find('[name=split_tunneling]').is(':checked');

        vpnForm.find('[name=vlan_ip],[name=virtual_subnet],[name=iprange_start],[name=iprange_end]:not(.invisible)').each(function() {
          addSettingValue($(this), settings);
        });

        vpnForm.find('[name=vpn_primary_dns_ip],[name=vpn_secondary_dns_ip],[name=vpn_dns_domain]:not(.invisible)').each(function() {
          addSettingValue($(this), settings.dns);
        });

        if(authType == 'AD') {
          vpnForm.find('[name=ip],[name=domain],[name=admin_name],[name=admin_password]:not(.invisible)').each(function() {
            addSettingValue($(this), settings.ad_config);
          });
          settings.ad_config.connection_type = vpnForm.find('[name=connection_type_value]').attr('data-secure');
        } else {
          vpnForm.find('.axtable.userlist .js-vpn:not(.js-template):visible').each(function () {
            var row = $(this),
             isDeleted = row.is('.deleted'),
             isNew = row.is('.new'),
             item, index;

            if(isDeleted) {
              item = index = row.data('user');
              settings.users.delete[index] = item;
            } else {
              item = row_to_object(row);
              index = get_row_index(row);
              if (!!item.username || !!item.password) {
                if(isNew) {
                  settings.users.add[index] = item;
                } else {
                  settings.users.stored[index] = item;
                }
              }
            }
          });
        }
        return settings;
      },
      /**
       * Collects PF data for Hotsite runbook
       * @private
       */
      collectHotsitePF: function(pane) {
        var pfForm = pane.find('.port_fwd_edit_form'),
         settings = {
           port_forward_enabled: +pfForm.find('[name=pf_enabled]').is(':checked'),
           pf_interfaces: []
         };

        pfForm.find('.axtable.hotsite_port_fwd_rules').each(function() {
          var $ruleTable = $(this),
           ruleIndex = $ruleTable.attr('data-ip_num');
          settings.pf_interfaces[ruleIndex] = {
            add: {},
            stored: {},
            delete: {}
          };
          $ruleTable.find('.js-pf:not(.js-template)').each(function(){
            var row = $(this),
             isNew = row.is('.new'),
             isDeleted = row.is('.deleted'),
             item, index;

            if (isNew) {
              item = row_to_object(row);
              index = get_row_index(row);
              if (!!item.ext_port || !!item.int_ip || !!item.int_port) {
                settings.pf_interfaces[ruleIndex].add[index] = item;
              }
            } else if (isDeleted) {
              item = index = row.data('pf_rule');
              settings.pf_interfaces[ruleIndex].delete[index] = index;
            } else {
              index = row.data('pf_rule');
              item = {
                ext_port: row.find('[name="ext_port['+index+']"]').text(),
                int_ip: row.find('[name="int_ip['+index+']"]').text(),
                int_port: row.find('[name="int_port['+index+']"]').text()
              };
              settings.pf_interfaces[ruleIndex].stored[index] = item;
            }
          });
        });
        return settings;
      },
      /**
       * Collects S2S data for Hotsite runbook.
       * @private
       */
      collectHotsiteS2S: function(pane) {
        var S2SForm = pane.find('.s2s_vpn_edit_form'),
         settings = {
           s2s_vpn_enabled: +S2SForm.find('[name=s2s_vpn_enabled]').is(':checked'),
           allowed_ips: {},
           endpoint: {}
         };

        S2SForm.find('.allowed_ips_list .row').each(function() {
          var allowedIp = $(this).find('input').val(),
           index = get_row_index($(this));
          if(!!allowedIp){
            settings.allowed_ips[index] = {allowed_ip: allowedIp};
          }
        });

        var endpointRecord = S2SForm.find('.endpoint.card'),
         endpointItem = row_to_object(endpointRecord);
        if(!!endpointItem.endpoint_name || !!endpointItem.key_password || !!endpointItem.endpoint_ip ||
         !!endpointItem.gateway || !!endpointItem.netmask || !!endpointItem.dns){
          settings.endpoint = endpointItem;
          settings.endpoint.config_type = endpointRecord.find('.config-type').attr('data-config');
        }

        return settings;
      },
      /**
       * Collects DHCP data for Hotsite runbook
       * @private
       */
      collectHotsiteDHCP: function(pane) {
        var addSettingValue = function(field, setting){
          var name = field.attr('name'),
           val = field.val();
          setting[name] = val;
        };

        var dhcpForm = pane.find('.dhcp_edit_form');
        settings = {
          dhcp_enabled: false,
          domain: '',
          range_start: '',
          range_end: '',
          dns_servers: {},
          mac_to_ip: {},
        };

        settings.dhcp_enabled = dhcpForm.find('[name=dhcp_enabled]').is(':checked');

        dhcpForm.find('[name=domain],[name=range_start],[name=range_end]').each(function() {
          addSettingValue($(this), settings);
        });

        dhcpForm.find('.dns_list .row').each(function() {
          var dnsServer = $(this).find('input').val(),
           index = get_row_index($(this));
          settings.dns_servers[index] = {dns_server: dnsServer};
        });

        dhcpForm.find('.mac2ip_list .row').each(function(){
          var $this = $(this),
							macAddress = $this.find('input.mac').val(),
							ipAddress = $this.find('input.ip').val(),
							index = get_row_index($this);
          settings.mac_to_ip[index] = {
            mac: macAddress,
            ip: ipAddress,
          }
        });

        return settings;
      },
      /**
       * Collects S2S IPSec data for Hotsite runbook
       * @private
       */
      collectHotsiteS2SIpSec: function(pane) {
        const settings = {
          s2s_ipsec_enabled: false,
          local_ipsec_id: {
            local_identifier_type: 'ip',
            local_identifier_name: '',
            local_identifier_ip: ''
          },
          remote_sites: {}
        };
        settings.s2s_ipsec_enabled = pane.find('[name=s2s_ipsec_enabled]').is(':checked');
        const s2sIpsecEditForm = pane.find('.s2s_ipsec_edit_form');
        if (s2sIpsecEditForm.find('#config_local_id_name').is(':checked')) {
          settings.local_ipsec_id.local_identifier_type = 'name';
          settings.local_ipsec_id.local_identifier_name = s2sIpsecEditForm.find('[name=local-name]').val();
        }
        s2sIpsecEditForm.find('.ipsec-site.record').each(function() {
          const remote_site = {
            name: '',
            public_ip: '',
            remote_subnets: [],
            remote_type: 'ip',
            remote_ip: '',
            remote_name: ''
          }

          const row = $(this);
          remote_site.num = row.data('num');
          remote_site.name = row.find('[name^=name]').val();
          remote_site.public_ip = row.find('[name^=public_ip]').val();
          if (row.find('[id^=config_remote_id_name').is(':checked')) {
            remote_site.remote_type = 'name';
            remote_site.remote_name = row.find('[name^=remote_name]').val();
          } else {
            remote_site.remote_ip = row.find('[name^=remote_ip]').val();
          }
          row.find('.item-label').each(function() {
            const site_remote_subnet = $(this).text();
            remote_site.remote_subnets.push(site_remote_subnet);
          });
          settings.remote_sites[remote_site.num] = remote_site;
        });

        return settings;
      },
      collect: function(pane) {
        if (isHotsiteRunbookGeneration(this.runbookGeneration)) {
          return {
            vpn: this.collectHotsiteVPN(pane),
            pf: this.collectHotsitePF(pane),
            dhcp: this.collectHotsiteDHCP(pane),
            s2s_vpn: this.collectHotsiteS2S(pane),
            s2s_ipsec: this.collectHotsiteS2SIpSec(pane)
          };
        } else {
          throwUnknownRunbookTypeError(this.runbookGeneration);
        }

      },
      validateBack: function(pane, data, noDataChanged, dataHasChanged) {
        if (pane.data('has_changed')) {
          dataHasChanged();
        } else {
          noDataChanged();
        }
      },
      validateNext: function(pane, data, validationSuccess, validationError) {
        pane.data('has_changed', false);

        var networkSettingsDataKey = 'step4',
            networkSettings = data.steps[networkSettingsDataKey] || {},
            voIp = networkSettings.gateway_ip || '',
            voNetmask = networkSettings.netmask || '',

            commonParams = {
              'client_id': data.client_id,
              'runbook_id': data.id || 0,
              'generation': data.runbookGeneration
            },
            vpnParams = {
              'advanced_settings': {
                vpn: data.steps[this.id].vpn
              }
            },
            pfParams = {
              'advanced_settings': {
                pf: data.steps[this.id].pf
              }
            },
            s2sParams = {
              'advanced_settings': {
                s2s_vpn: data.steps[this.id].s2s_vpn
              }
            },
            s2sIpSecParams = {
              'advanced_settings': {
                s2s_ipsec: data.steps[this.id].s2s_ipsec
              }
            },
            dhcpParams = {
              'advanced_settings': {
                dhcp: data.steps[this.id].dhcp
              }
            },
            success = function() {
              validationSuccess();
            },
            fail = function(validationErrors) {
              validationError();
              runbookFlow.showErrors(pane, validationErrors);
            };

            if (isHotsiteRunbookGeneration(data.runbookGeneration)) {
              var validationSettings = {
								'device_ids' : Object.keys(data.steps["step2"].list) || [],
                'network_settings' : networkSettings,
                'advanced_settings' : {
                  'vpn' : vpnParams.advanced_settings.vpn,
                  'port_forward' : pfParams.advanced_settings.pf,
                  'dhcp' : dhcpParams.advanced_settings.dhcp,
                  's2s_vpn' : s2sParams.advanced_settings.s2s_vpn,
                  's2s_ipsec' : s2sIpSecParams.advanced_settings.s2s_ipsec
                }
              };
              RUNBOOK_ACTIONS_MANAGER.hotsiteAdvanced().validate($.extend(validationSettings, commonParams), success, fail);
            } else {
              throwUnknownRunbookTypeError(data.runbookGeneration);
            }

      },
      updateBtnsState: function(pane, data) {
        var pfForm = pane.find('.port_fwd_edit_form'),
            hasRules = pfForm.find('.js-pf.trow:not(.deleted):not(:last)').length > 0,
            isEnabled = pfForm.find('[name="pf_enabled"]').is(':checked');

        pane.find(nextBtn).removeClass('disabled');
      }
    },
    // step6
    {
      id: 'step6',
      view: 'finish',
      afterPaneLoad: function(pane, data) {
        var itemsSummaryDataKey = 'step1',
            itemsListDataKey = 'step2',
            runbookSummary = data.steps[itemsSummaryDataKey],
            itemsList = {};

        //hotfix for BRC runbook
        if(data.steps[itemsListDataKey] && data.steps[itemsListDataKey].list){
          itemsList = data.steps[itemsListDataKey].list;
        }

        pane.find('#runbook-name').text(runbookSummary.runbook_name);
        pane.find('#runbook-desc').text(runbookSummary.runbook_description || '--');
        pane.find('#runbook-items-count').text(Object.keys(itemsList).length);
      }
    }
  ];

  this.axWizardStepFactory = function(options) {
    return {open: function(context) {
      context.options.data = context.options.data || {};
      context.options.data.steps = context.options.data.steps || {};

      var data = context.options.data,

          clientId = data.client_id,
          runbookId = data.id || 0,

          pane = context.$container.find('[id="#' + options.id + '"]');

      if (typeof options.beforePaneLoad === 'function') {
        options.beforePaneLoad(pane, data);
      }

      var paneUrl = runbookFlow.wizardUrl + options.view + '/' + clientId + '/' + runbookId;
      pane.empty().load(paneUrl, data, function() {
        var disableBtns = function() { pane.find(btnsSelector).addClass('disabled'); },
            enableBtns = function() { pane.find(btnsSelector).removeClass('disabled'); },
            updateBtnsState = function() {
              enableBtns();
              if (typeof options.updateBtnsState === 'function') {
                options.updateBtnsState(pane, data);
              }
            },

            removeFocus = function() {
              pane.find(':focus').blur();
            },

            disablePane = function() {
              pane.addClass('disabled');
            },
            enablePane = function() {
              pane.removeClass('disabled');
            },

            nextBtnClick = function() {
              removeFocus();
              disableBtns();
              disablePane();
              runbookFlow.clearErrors(pane);

              data.steps[options.id] = data.steps[options.id] || {};

              if (typeof options.collect === 'function') {
                data.steps[options.id] = options.collect(pane) || {};
                pane.trigger('pane-'+options.id+'-collected');
              }

              var validationSuccess = function() {
                    updateBtnsState();
                    enablePane();
                    context.nextStep();
                  },
                  validationError = function() {
                    enablePane();
                    updateBtnsState();
                  },
                  validationErrorPrev = function() {
                    updateBtnsState();
                    enablePane();
                    context.prevStep();
                  };

              // validate data for the next step
              if (typeof options.validateNext === 'function') {
                options.validateNext(pane, data, validationSuccess, validationError, validationErrorPrev);
              } else {
                validationSuccess();
              }
            },

            backBtnClick = function() {
              removeFocus();
              disableBtns();
              disablePane();

              var noDataChanged = function() {
                    updateBtnsState();
                    enablePane();

                    context.prevStep();
                  },
                  dataHasChanged = function() {
                    var afterDlgCreate = function() {
                          updateBtnsState();
                          enablePane();
                        },
                        proceedFunction = function() {
                          context.prevStep();
                        };
                    RUNBOOK_DIALOGS.goBackWithDialog(afterDlgCreate, proceedFunction);
                  };

              if (typeof options.validateBack === 'function') {
                options.validateBack(pane, data, noDataChanged, dataHasChanged);
              } else {
                noDataChanged();
              }
            },

            finishBtnClick = function() {
              removeFocus();
              disableBtns();
              disablePane();
              runbookFlow.clearErrors(pane);

              data.steps[options.id] = data.steps[options.id] || {};

              if (typeof options.collect === 'function') {
                data.steps[options.id] = options.collect(pane) || {};
                pane.trigger('pane-'+options.id+'-collected');
              }

              var saveSuccess = function() {
                    enablePane();
                    context.reset();
                  },
                  saveFailed = function() {
                    context.refresh();
                    enablePane();
                  },
                  validationError = function() {
                    updateBtnsState();
                    enablePane();
                  },
                  saveRunbook = function() {
                    runbookFlow.saveRunbook(data, saveSuccess, saveFailed);
                  };

              if (typeof options.validateNext === 'function') {
                options.validateNext(pane, data, saveRunbook, validationError);
              } else {
                saveRunbook();
              }
            };

        pane.on('keydown', ':input:not(.tokenfield-input)', event => {
          if (event.keyCode === 13) {
            event.preventDefault();
            nextBtnClick();
            return false;
          }
        });

        pane.off('click', nextBtn+notDisabled)
            .off('click', backBtn+notDisabled)
            .off('click', finishBtn+notDisabled)
            .on('click', nextBtn+notDisabled, nextBtnClick)
            .on('click', backBtn+notDisabled, backBtnClick)
            .on('click', finishBtn+notDisabled, finishBtnClick);

        updateBtnsState();

        if (typeof options.afterPaneLoad === 'function') {
          options.afterPaneLoad(pane, data);
        }
      });
    }};
  };

  this.prepareSteps = function() {
    var result = [];

    $.each(runbookFlow.steps, function(i, step) {
      result.push(runbookFlow.axWizardStepFactory(step));
    });

    return result;
  };

  return this.prepareSteps();
}

/**
 * Runbook dialogs
 */
RUNBOOK_DIALOGS = {
  dialogsUrl: '/runbook/dialogs/',
  commonDlgOptions: {
    modal: true,
    width: '900',
    minWidth: '700',
    minHeight: '500',
    draggable: false,
    resizable: false,
    closeText: _close_label,
    dialogClass: 'axDialog',
    title: '',
    close: function() {
      tmp = {};
      $(this).dialog('destroy');
      $(this).remove();
    },
    buttons: []
  },
  /**
   * Sets element's text and adds axTooltip for the element.
   * @private
   */
  setElValue: function(container, elClass, value, setAsHtml) {
    var el = $(container).find(elClass);
    if (!!setAsHtml) {
      el.html(value);
    } else {
      el.text(value);
    }
    el.attr('data-axTooltip', value);
    el.attr('data-axtooltip-trunc', true);
  },
  /**
   * Creates runbook dialog.
   * @private
   */
  createDialog: function(dialogId, templateUrl, customOptions, afterDlgCreate, afterDlgShow) {
    var dlg = $('#' + dialogId),
        options = {};
    $.extend(options, this.commonDlgOptions);

    if (!dlg.length) {
      dlg = $('<div id="'+dialogId+'" class="runbook-dialog" style="display: none;"></div>');
      $('#content').after(dlg);
    }

    if (typeof customOptions === 'object') {
      $.extend(true, options, customOptions);
    }

    dlg.addClass('loading');
    dlg.load(templateUrl, function() {
      var title = dlg.find('[data-title]');
      if (title.length) {
        options.title = title.data('title');
      }

      dlg.dialog(options);

      if (typeof afterDlgCreate === 'function') {
        afterDlgCreate(dlg);
      }

      dlg.dialog('open');

      dlg.removeClass('loading');

      if (afterDlgShow) {
        afterDlgShow(dlg);
      }
    });

    return dlg;
  },
  errorDialog: function(errorMessage) {
    _error_dlg(errorMessage);
  },
  goBackWithDialog: function(afterDlgCreate, proceedFunction) {
    var url = '/dialog/runbook_navigate_back',
        customOptions = {
          width: '700',
          minWidth: '600',
          minHeight: '100'
        };

    return this.createDialog('navigate_back_dlg', url, customOptions, function(dlg) {
      dlg.find('.axButtons .proceed-btn').on('click', function() {
        dlg.dialog('destroy').remove();
        if (typeof proceedFunction === 'function') {
          proceedFunction();
        }
      });

      dlg.find('.axButtons .cancel-btn').on('click', function() {
        dlg.dialog('destroy').remove();
      });

      if (typeof afterDlgCreate === 'function') {
        afterDlgCreate(dlg);
      }
    });
  },
  showRunbookWarningsDialog: function(warnings, afterDlgCreate,
                                      closeFunction, actionFunction, actionPrevFunction, runbookGeneration, skipFunction) {
    var self = this,
      url = '/dialog/runbook_items_errors',
        customOptions = {
          width: '700',
          minWidth: '600',
          minHeight: '450',
          close: function() {
            if (typeof closeFunction === 'function') {
              closeFunction();
            }

            $(this).dialog('destroy');
            $(this).remove();
          }
        };

    return this.createDialog('runbook_warnings_dlg', url, customOptions, function(dlg) {
      if (typeof afterDlgCreate === 'function') {
        afterDlgCreate(dlg);
      }

      var entityTitle;
      if (isHotsiteRunbookGeneration(runbookGeneration)) {
        entityTitle = _brc_entity_title;
      } else {
        throwUnknownRunbookTypeError(runbookGeneration);
      }

      dlg.find('.devices-with-errors .axtableview .headers-container .errentityname').text(entityTitle);

      var $tbl_content = dlg.find('.devices-with-errors .axtableview .axtable-content-container');
      var $clonable = $tbl_content.find('.trow:last');

      for (var i in warnings) {
        var $row = $clonable.clone();
        self.setElValue($row, '.errdevicename', warnings[i].name);
        self.setElValue($row, '.errdeviceaddress', warnings[i].address);

        if (isHotsiteRunbookGeneration(runbookGeneration)) {
          self.setElValue($row, '.errentityname', warnings[i].service_id);
        } else {
          throwUnknownRunbookTypeError(runbookGeneration);
        }

        var error_labels = warnings[i].error_labels;
        error_labels = error_labels.join();
        self.setElValue($row, '.errorname', error_labels.split(',').join('<br />'), true);

        $row.insertBefore($clonable);
        $row.show();
      }

      dlg.find('.axButtons .js-close-btn').click(function(){
        if (typeof skipFunction === 'function') {
					skipFunction();
        }

        dlg.dialog('destroy').remove();
      });

      dlg.find('.axButtons .js-action-btn').click(function(){
        if (typeof actionFunction === 'function') {
          actionFunction();
        }

        dlg.dialog('destroy').remove();
      });

      dlg.find('.axButtons .js-action-btn-prev').click(function(){
        if (typeof actionPrevFunction === 'function') {
          actionPrevFunction();
        }

        dlg.dialog('destroy').remove();
      });
    }, dlg => alignHeaderOnLimitedHeightTable(dlg));
  },
  showRunbookDeviceWarningsDialog: function (warnings, skipFunction, addDevicesFunction, runbookGeneration) {
    var afterDlgCreate = function(dlg) {
          dlg.find('.axButtons .js-close-btn span').text(_skip_label);
          dlg.find('.axButtons .js-action-btn span').text(_add_remove_devices_label);
        },
        closeFunction = addDevicesFunction,
        actionFunction = addDevicesFunction;

    return this.showRunbookWarningsDialog(warnings, afterDlgCreate, closeFunction, actionFunction, null, runbookGeneration, skipFunction);
  },
  showRunbookStartWarningsDialog: function(warnings, closeFunction, startRunbookFunction, runbookGeneration) {
    var afterDlgCreate = function(dlg) {
          dlg.find('.axButtons .js-close-btn span').text(_close_label);
          dlg.find('.axButtons .js-action-btn span').text(_start_runbook_label);
        },
        actionFunction = startRunbookFunction;
				skipFunction = closeFunction;

    return this.showRunbookWarningsDialog(warnings, afterDlgCreate, closeFunction, actionFunction, null,runbookGeneration, skipFunction);
  },
  showEditValuesDialog: function(rbId, generation, afterDlgCreate, saveFunction) {
    var dialogUrl;
    if (isHotsiteRunbookGeneration(generation)) {
      dialogUrl = '/dialog/edit_hotsite_runbook_values';
    } else {
      throwUnknownRunbookTypeError(generation);
    }

    var url = dialogUrl,
        customOptions = {
          width: '700',
          minWidth: '600',
          minHeight: '300'
        },
        dialogId = 'edit_runbook_values' + (rbId ? '_'+rbId : '');

    return this.createDialog(dialogId, url, customOptions, function(dlg) {
      var $errorMessageBlock = dlg.find('.infobox--error');
      dlg.on('click', '.save-btn:not(.disabled)', function() {
        var closeDialog = true;
        if (typeof saveFunction === 'function') {
          closeDialog = saveFunction(dlg);
        }
        if (closeDialog) {
          dlg.dialog('destroy').remove();
        }
        else {
          $errorMessageBlock.fadeIn();
        }
      });
      dlg.on('click', '.buttons-flex .cancel', function(){
        dlg.dialog('destroy').remove();
      });

      if (typeof afterDlgCreate === 'function') {
        afterDlgCreate(dlg);
      }
    });
  },
  showDeleteDialog: function(clientId, runbookIds, cancelFunction, deleteRunbooksFunction) {
    var runbooksCount = runbookIds.length,

        countSegment = runbooksCount+'/',
        clientIdSegment = clientId+'/',
        runbookIdSegment = runbooksCount === 1 ? runbookIds[0] + '/' : '',
        params = countSegment+clientIdSegment+runbookIdSegment,

        url = this.dialogsUrl + 'load_delete_runbook_dialog/'+params,
        customOptions = {
          width: '700',
          minWidth: '600',
          minHeight: '300',
          close: function() {
            if (typeof cancelFunction === 'function') {
              cancelFunction();
            }
            $(this).dialog('destroy').remove();
          }
        };

    return this.createDialog('delete_runbook_dlg', url, customOptions, function(dlg) {
      dlg.find('.axButtons .cancel').click(function() {
        if (typeof cancelFunction === 'function') {
          cancelFunction();
        }
        dlg.dialog('destroy').remove();
      });
      dlg.find('.axButtons .delete').click(function() {
        dlg.dialog('destroy').remove();
        if (typeof deleteRunbooksFunction === 'function') {
          deleteRunbooksFunction();
        }
      });
    });
  }
};

RUNBOOK_ACTIONS_MANAGER = {
  /**
   * Constants with paths of different runbook controllers.
   * @private
   */
  url: function() {
    var baseUrl = '/runbook';

    return {
      summary: baseUrl + '/summary/',
      items: baseUrl + '/items/',
      network: baseUrl + '/network/',
      hotsiteAdvanced: baseUrl + '/advanced/',

      actions: baseUrl + '/actions/'
    }
  },

  /**
   * Returns error message from response.
   * @private
   * @param  {Object}   response    [description]
   * @param  {String}   default     [description]
   * @return {String}               [description]
   */
  _getResponseErrorMessage: function(response, default_message) {
    return ((response || {}).errors || {})['_message_'] || default_message || '';
  },

  /**
   * Makes ajax request and handle response.
   * @private
   * @return {jqXHR}                  [description]
   * @param url
   * @param action
   * @param data
   * @param onSuccessResponse
   * @param onErrorResponse
   * @param onRequestSuccess
   * @param onRequestFailed
   */
  _do: function(url, action, data,
                onSuccessResponse,
                onErrorResponse,
                onRequestSuccess,
                onRequestFailed) {
    return $.ajax({
      url: url + action,
      type: 'POST',
      data: data,
      dataType: 'json'
    }).done(function(response, status, jqXHR) {
      if (typeof onRequestSuccess === 'function') {
        onRequestSuccess(response);
      }

      var isError = !!(response || {}).is_error;

      if (isError) {
        if (typeof onErrorResponse === 'function') {
          onErrorResponse(response);
        }
      } else {
        if (typeof onSuccessResponse === 'function') {
          onSuccessResponse(response);
        }
      }
    }).fail(function(jqXHR, status, error) {
      if (typeof onRequestFailed === 'function') {
        onRequestFailed(jqXHR, status, error);
      }
    });
  },

  /**
   * A factory that return the handlers for failed requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _requestFailedFactory: function(callback) {
    return function(jqXHR, status, error) {
      if (typeof callback === 'function') {
        callback();
      }

      ajax_error_handler(jqXHR, status, error);
    };
  },

  /**
   * A factory that return the handlers for success validation requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _validationResponseSuccessFactory: function(validationSuccessCallback,
                                              validationFailedCallback) {
    return function(response) {
      var validationErrors = (response || {}).validation_errors || {};

      if (!$.isEmptyObject(validationErrors)) {
        if (typeof validationFailedCallback === 'function') {
          validationFailedCallback(validationErrors);
        }
      } else {
        if (typeof validationSuccessCallback === 'function') {
          validationSuccessCallback();
        }
      }
    };
  },

  /**
   * A factory that return the handlers for failed validation requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _validationResponseErrorFactory: function(validationFailedCallback) {
    var self = this;
    return function(response) {
      if (typeof validationFailedCallback === 'function') {
        validationFailedCallback();
      }

      var errorMsg = self._getResponseErrorMessage(response, err_operation_failed);
      RUNBOOK_DIALOGS.errorDialog(errorMsg);
    };
  },

  /**
   * Makes ajax request to validate provided data and handle response.
   * @private
   * @param  {String}   url               [description]
   * @param  {String}   action            [description]
   * @param  {Object}   data              [description]
   * @param  {Function} validationSuccess [description]
   * @param  {Function} validationFailed  [description]
   * @return {jqXHR}                      [description]
   */
  _validate: function(url, action, data,
                      validationSuccess,
                      validationFailed) {
    var self = this,
        onSuccessResponse = self._validationResponseSuccessFactory(validationSuccess, validationFailed),
        onErrorResponse = self._validationResponseErrorFactory(validationFailed),
        onRequestFailed = self._requestFailedFactory(validationFailed);
    return self._do(url, action, data,
                    onSuccessResponse,
                    onErrorResponse,
                    null,
                    onRequestFailed);
  },

  /**
   * A factory that return the handlers for success save requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _saveResponseSuccessFactory: function(saveSuccessCallback) {
    return function(response) {
      if (typeof saveSuccessCallback === 'function') {
        saveSuccessCallback(response);
      }
    };
  },

  /**
   * A factory that return the handlers for failed save requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _saveResponseErrorFactory: function(saveFailedCallback) {
    var self = this;
    return function(response) {
      if (typeof saveFailedCallback === 'function') {
        saveFailedCallback(response);
      }

      var validation = (response || {}).validation_errors || {},
          details = validation.details || {},
          messages = [],
          errorMessage = self._getResponseErrorMessage(response, err_operation_failed);
      delete validation.details;

      $.each(validation, function(key, message) {
        if ($.inArray(message, messages) === -1) {
          messages.push(message);
        }
      });

      if (messages.length === 0) {
        $.each(details, function(key, message) {
          if ($.inArray(message, messages) === -1) {
            messages.push(message);
          }
        });
      }

      if (messages.length === 0) {
        messages.push(errorMessage);
      }

      RUNBOOK_DIALOGS.errorDialog(messages.join('<br />'));
    };
  },

  /**
   * Makes ajax request to save provided data and handle response.
   * @private
   * @param  {String}   url         [description]
   * @param  {String}   action      [description]
   * @param  {Object}   data        [description]
   * @param  {Function} saveSuccess [description]
   * @param  {Function} saveFailed  [description]
   * @return {jqXHR}                [description]
   */
  _save: function(url, action, data,
                  saveSuccess,
                  saveFailed) {
    var self = this,
        onSuccessResponse = self._saveResponseSuccessFactory(saveSuccess),
        onErrorResponse = self._saveResponseErrorFactory(saveFailed),
        onRequestFailed = self._requestFailedFactory(saveFailed);
    return self._do(url, action, data,
                    onSuccessResponse,
                    onErrorResponse,
                    null,
                    onRequestFailed);
  },

  /**
   * A factory that return the handlers for failed action requests.
   * @private
   * @param  {Function} callback        [description]
   * @return {Function}                 [description]
   */
  _actionResponseErrorFactory: function(actionFailedCallback) {
    var self = this;
    return function(response) {
      if (typeof actionFailedCallback === 'function') {
        actionFailedCallback();
      }

      var errorMsg = self._getResponseErrorMessage(response, err_operation_failed);
      RUNBOOK_DIALOGS.errorDialog(errorMsg);
    };
  },

  /**
   * Makes ajax request to make some action and handle response.
   * @private
   * @param  {String}   url           [description]
   * @param  {String}   action        [description]
   * @param  {Object}   data          [description]
   * @param  {Function} actionSuccess [description]
   * @param  {Function} actionFailed  [description]
   * @return {jqXHR}                  [description]
   */
  _doAction: function(action, data, actionSuccess, actionFailed) {
    var self = this,
        onSuccessResponse = actionSuccess,
        onErrorResponse = self._actionResponseErrorFactory(actionFailed),
        onRequestFailed = self._requestFailedFactory(actionFailed);

    return self._do(self.url().actions, action, data,
                    onSuccessResponse,
                    onErrorResponse,
                    null,
                    onRequestFailed);
  },


  actions: function() {
    var self = this;
    return {
      check: function(data, checkSuccess, checkError) {
        return self._doAction('check', data, checkSuccess, checkError);
      },
      delete: function(data, deleteSuccess, deleteError) {
        return self._doAction('delete', data, deleteSuccess, deleteError);
      },
      clone: function(data, cloneSuccess, cloneError) {
        return self._doAction('clone', data, cloneSuccess, cloneError);
      },
      verify_password: function(data, cloneSuccess, cloneError) {
        return self._doAction('verify_runbook_password', data, cloneSuccess, cloneError);
      }
    };
  },

  summary: function() {
    var self = this;
    return {
      validate: function(data, validationSuccess, validationFailed) {
        return self._validate(self.url().summary, 'validate', data, validationSuccess, validationFailed);
      },
      save: function(data, saveSuccess, saveFailed) {
        return self._save(self.url().summary, 'save', data, saveSuccess, saveFailed);
      }
    };
  },

  items: function() {
    var self = this;
    return {
      check: function(data, validationSuccess, validationFailed) {
        return self._validate(self.url().items, 'check', data, validationSuccess, validationFailed);
      },
      verify_passwords: function(data, validationSuccess, validationFailed) {
        return self._validate(self.url().items, 'verify_passwords', data, validationSuccess, validationFailed);
      },
      check_resources: function(data, validationSuccess, validationFailed) {
        return self._validate(self.url().items, 'check_resources', data, validationSuccess, validationFailed);
      },
      get_resources: function(data, getSuccess, getFailed) {
        return self._save(self.url().items, 'get_resources', data, getSuccess, getFailed);
      },
      add: function(data, saveSuccess, saveFailed) {
        return self._save(self.url().items, 'add', data, saveSuccess, saveFailed);
      },
      update: function(data, updateSuccess, updateFailed) {
        return self._save(self.url().items, 'update', data, updateSuccess, updateFailed);
      },
      delete: function(data, deleteSuccess, deleteFailed) {
        return self._save(self.url().items, 'delete', data, deleteSuccess, deleteFailed);
      }
    };
  },

  network: function() {
    var self = this;
    return {
      validate: function(data, validationSuccess, validationFailed) {
        return self._validate(self.url().network, 'validate', data, validationSuccess, validationFailed);
      },
      save: function(data, saveSuccess, saveFailed) {
        return self._save(self.url().network, 'save', data, saveSuccess, saveFailed);
      }
    };
  },

  hotsiteAdvanced: function() {
    var self = this;
    return {
      validate: function(advancedData, validationSuccess, validationFailed) {
        var success = function (response) {
           var isError = response.is_error || 0;
           if (!isError) {
             self._validationResponseSuccessFactory(validationSuccess, validationFailed)(response);
           } else {
             var fakeResponse = {
               errors: {
                 '_message_': (
                  self._getResponseErrorMessage(response),
                  err_operation_failed
                 )
               }
             };
             self._validationResponseErrorFactory(validationFailed)(fakeResponse);
           }
         },
         fail = self._requestFailedFactory(validationFailed);
        return $.when(
         self._do(self.url().hotsiteAdvanced, 'validate', advancedData)
        ).then(success, fail);
      },
      save: function(advancedData, saveSuccess, saveFailed) {
        var success = function (response) {
           var isError = response.is_error || 0;
           if (!isError) {
             self._saveResponseSuccessFactory(saveSuccess)(response);
           } else {
             self._saveResponseErrorFactory(saveFailed)(response);
           }
         },
         fail = self._requestFailedFactory(saveFailed);
        return $.when(
         self._do(self.url().hotsiteAdvanced, 'save', advancedData)
        ).then(success, fail);
      }
    };
  }
};

var RUNBOOK_STATES = {
  INCOMPLETE: 'INCOMPLETE',
  NOT_RUNNING: 'NOT_RUNNING',
  STARTING: 'STARTING',
  STARTED: 'STARTED',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  DISCARDING: 'DISCARDING'
};

/**
 * Runbook's page manager
 */
function RunbookManager(runbookManagerData) {
  var options = runbookManagerData || {},
      runbooks = {},
      wait = false;

  /**
   * Blocks all action.
   * @private
   */
  this.wait = function() {
    wait = true;
  };
  /**
   * Unblock available actions
   * @private
   */
  this.waitNoMore = function() {
    wait = false;
  };
  this.isWait = function() {
    return wait;
  };

  /**
   * Returns runbook data.
   * @private
   */
  this.getRunbookData = function(runbookId) {
    return runbooks[runbookId] || {};
  };
  /**
   * Returns runbook state.
   * @private
   */
  this.getRunbookState = function(runbookId) {
    return this.getRunbookData(runbookId).state;
  };

  /**
   * Checks if the runbook is non accessible.
   * @private
   */
  this.isNonAccessible = function (runbookId) {
    return this.getRunbookData(runbookId).is_non_accessible;
  };

  /**
   * Updates runbook data.
   * @private
   */
  this.updateRunbookData = function(runbookId, runbookData) {
    runbooks[runbookId] = $.extend(true, {}, runbooks[runbookId] || {}, runbookData);
  };
  /**
   * Updates runbooks data.
   */
  this.updateRunbooksData = function(data) {
    var self = this;
    $.each(data, function(i, row) {
      var rowData = row.rowAttr || {},
          rowContent = row.rowData || {},
          runbookId = rowData.id,
          runbookData = $.extend(true, {}, rowData, rowContent);

      if (!runbookId) {
        return;
      }
      self.updateRunbookData(runbookId, runbookData);
    });
  };

  this.isOffline = function(runbookState) {
    return ([RUNBOOK_STATES.INCOMPLETE,
             RUNBOOK_STATES.NOT_RUNNING].indexOf(runbookState) !== -1);
  };
  this.isRunning = function(runbookState) {
    return ([RUNBOOK_STATES.STARTING,
             RUNBOOK_STATES.STARTED,
             RUNBOOK_STATES.STOPPING,
             RUNBOOK_STATES.STOPPED,
             RUNBOOK_STATES.DISCARDING].indexOf(runbookState) !== -1);
  };

  this.hasRunningVO = function(runbookGeneration) {
    return voIds[runbookGeneration] !== null && voIds[runbookGeneration] !== undefined;
  };

  this.isEditAvailable = function(runbookState, isNonAccessible) {
    return (([RUNBOOK_STATES.INCOMPLETE,
              RUNBOOK_STATES.NOT_RUNNING,
              RUNBOOK_STATES.STARTED,
              RUNBOOK_STATES.STOPPED].indexOf(runbookState) !== -1) && (!isNonAccessible));
  };
  this.isCloneAvailable = function(runbookState, isNonAccessible) {
    return ((RUNBOOK_STATES.DISCARDING !== runbookState) && (!isNonAccessible));
  };
  this.isStartAvailable = function(runbookState, isNonAccessible) {
    return ((RUNBOOK_STATES.NOT_RUNNING === runbookState) && (!isNonAccessible));
  };
  this.isDeleteAvailable = function(runbookState) {
    return ([RUNBOOK_STATES.INCOMPLETE,
             RUNBOOK_STATES.NOT_RUNNING].indexOf(runbookState) !== -1);
  };

  this.getRunbookStatus = function(runbookId) {
    var self = this,
        runbookState = this.getRunbookState(runbookId),
        isNonAccessible = this.isNonAccessible(runbookId);
    return {
      state: runbookState,
      isOffline: self.isOffline(runbookState),
      isRunning: self.isRunning(runbookState),
      editAvailable: self.isEditAvailable(runbookState, isNonAccessible),
      cloneAvailable: self.isCloneAvailable(runbookState, isNonAccessible),
      startAvailable: self.isStartAvailable(runbookState, isNonAccessible),
      deleteAvailable: self.isDeleteAvailable(runbookState)
    };
  };

  /**
   * Returns available actions for runbook.
   * @private
   */
  this.getStatus = function(runbookIds) {
    var self = this,
        runbooksCount = runbookIds.length,

        hasNoRunbooks = runbooksCount === 0,
        hasSingleRunbook = runbooksCount === 1,

        firstRunbookGeneration = this.getRunbookData(runbookIds[0]).generation,
        hasRunningVO = this.hasRunningVO(firstRunbookGeneration),

        isWait = this.isWait(),

        status = {isWait: isWait};

    if (isWait) {
      return status;
    }

    status.createAvailable = true;
    if (hasNoRunbooks) {
      return status;
    }

    status.editAvailable = hasSingleRunbook,
    status.cloneAvailable = hasSingleRunbook,
    status.startAvailable = hasSingleRunbook && !hasRunningVO,
    status.deleteAvailable = true;

    $.each(runbookIds || [], function(i, runbookId) {
      var runbookStatus = self.getRunbookStatus(runbookId);
      status.editAvailable &= runbookStatus.editAvailable;
      status.cloneAvailable &= runbookStatus.cloneAvailable;
      status.startAvailable &= runbookStatus.startAvailable;
      status.deleteAvailable &= runbookStatus.deleteAvailable;
    });

    return status;
  };

  /**
   * @param  {[String]} containerSelector [description]
   * @param  {[Object]} containerData     [description]
   * @return
   */
  this.launchRunbookFlow = function(containerSelector, containerData, updateRunbookSummaryState) {
    const loadEditRunbookContainer = function(runbookManager) {
      container = $(containerSelector);

      if (!container.length) {
        container = null;
        console.log(containerSelector+' container doesn\'t exist!');
        return;
      }

      container.trigger('flow-started');

      var runbookState = (containerData || {}).state;

      if (runbookState) {
        container.attr('data-state', runbookState);
      }

      // create wizard
      container.axWizard({
        data: $.extend({}, options, containerData),
        steps: new RunbookFlow(runbookManager)
      });
    }

    if (containerData !== undefined) {
      onVerifyPasswordSuccess = function(response) {
        clearErrors($('#runbook_summary_section'));
        if (!$.isEmptyObject(response.validation_errors)) {
          handleRunbookPasswordError(response.validation_errors, function() {
            updateRunbookSummaryState();
          });
        } else {
          loadEditRunbookContainer(this);
        }
      };
      onStartError = function() {
        self.waitNoMore();
        if (typeof updateRunbookSummaryState === 'function') {
          updateRunbookSummaryState();
        }
      };
      RUNBOOK_ACTIONS_MANAGER.actions().verify_password(containerData, onVerifyPasswordSuccess, onStartError);
    } else {
      loadEditRunbookContainer(this);
    }
  };

  this.flowFinished = function(runbookId) {
    container.trigger('flow-ended', [runbookId]);
  };

  /**
   * Delete Runbooks
   * @param [Array] runbookIds [description]
   */
  this.delete = function(clientId, runbookIds, deleteSuccess, deleteError, deleteCancelled) {
    var self = this;
    this.wait();

    var data = {'client_id': clientId,
                'runbook_ids': runbookIds},

        onDeleteSuccess = function() {
          self.waitNoMore();
          if (typeof deleteSuccess === 'function') {
            deleteSuccess();
          }
        },
        onDeleteError = function() {
          self.waitNoMore();
          if (typeof deleteError === 'function') {
            deleteError();
          }
        },

        onDeleteCancel = function() {
          self.waitNoMore();
          if (typeof deleteCancelled === 'function') {
            deleteCancelled();
          }
        },
        onDelete = function() {
          RUNBOOK_ACTIONS_MANAGER.actions().delete(data, onDeleteSuccess, onDeleteError);
        };

    RUNBOOK_DIALOGS.showDeleteDialog(clientId, runbookIds, onDeleteCancel, onDelete);
  };

  /**
   * Start Runbook
   */
  this.start = function(clientId, runbookId, runbookGeneration, runbookPassword, isAutoStopEnabled, startSuccess, startError, startCancelled) {
    var self = this;
    this.wait();

    var data = {
          'client_id': clientId,
          'runbook_id': runbookId,
          'password': runbookPassword
        },

        onStartSuccess = function() {
          self.waitNoMore();
          if (typeof startSuccess === 'function') {
            startSuccess();
          }
          tabs_goto();
        },
        onStartError = function() {
          self.waitNoMore();
          if (typeof startError === 'function') {
            startError();
          }
        },

        onStartCancel = function() {
          self.waitNoMore();
          if (typeof startCancelled === 'function') {
            startCancelled();
          }
        },
        onStart = function() {
          if(runbookGeneration == BRC_GENERATION || runbookGeneration == RB_GENERATION) {
            const context = {
              'clientId': clientId, 'runbookId': runbookId, 'password': runbookPassword,
              'startStep': 'setRunbookVirtualizationType', isAutoStopEnabled: isAutoStopEnabled
            };
            if (runbookGeneration == BRC_GENERATION) {
              runGen2RecoverFlow(context, onStartSuccess);
            } else if (runbookGeneration == RB_GENERATION) {
              runGen4RecoverFlow(context, onStartSuccess);
            }
					} else {
            throwUnknownRunbookTypeError(runbookGeneration);
          }
        },

        onCheckSuccess = function(response) {
          var warnings = (response || {}).warnings || {};
          if (!$.isEmptyObject(warnings)) {
            RUNBOOK_DIALOGS.showRunbookStartWarningsDialog(warnings, onStartCancel, onStart, runbookGeneration);
          } else {
            onStart();
          }
        },
        onCheckError = function() {
          onStartError();
        },
        onVerifyPasswordSuccess = function(response) {
          clearErrors($('#runbook_summary_section'));
          if (!$.isEmptyObject(response.validation_errors)) {
            handleRunbookPasswordError(response.validation_errors, function() {
              onStartCancel();
            });
          } else {
            RUNBOOK_ACTIONS_MANAGER.actions().check(data, onCheckSuccess, onCheckError);
          }
        };

    RUNBOOK_ACTIONS_MANAGER.actions().verify_password(data, onVerifyPasswordSuccess, onStartError);
  };

  /**
   * Clone Runbook
   */
  this.clone = function(clientId, runbookId, runbookPassword, cloneSuccess, cloneError) {
    var self = this;
    this.wait();

    var data = {
        'client_id': clientId,
        'runbook_id': runbookId,
        'password': runbookPassword
      },
      onCloneSuccess = function(response) {
        self.waitNoMore();
        if (typeof cloneSuccess === 'function') {
          cloneSuccess(response);
        }
      },
      onCloneError = function(response) {
        self.waitNoMore();
        if (typeof cloneError === 'function') {
          cloneError(response);
        }
      },
      onVerifyPasswordSuccess = function(response) {
        clearErrors($('#runbook_summary_section'));
        if (!$.isEmptyObject(response.validation_errors)) {
          handleRunbookPasswordError(response.validation_errors, function() {
            self.waitNoMore();
            cloneError();
          });
        } else {
          RUNBOOK_ACTIONS_MANAGER.actions().clone(data, onCloneSuccess, onCloneError);
        }
      };
    RUNBOOK_ACTIONS_MANAGER.actions().verify_password(data, onVerifyPasswordSuccess, cloneError);

  };
}
